import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QueuePreviewComponent } from './queue-preview.component';
import { PipesModule } from '../pipes/pipes.module';
import { FormsModule } from '@angular/forms';
import { PersonAvatarModule } from '../person-avatar/person-avatar.module';



@NgModule({
  declarations: [
    QueuePreviewComponent
  ],
  imports: [
    CommonModule,PipesModule,FormsModule,PersonAvatarModule
  ]
})
export class QueuePreviewModule { }
